import CheckIcon from '@mui/icons-material/Check';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { Checkbox as MuiCheckbox } from '@mui/material';
import { memo } from 'react';

type Props = {
  checked: boolean;
  onChange: () => void;
  disabled: boolean;
};

export const Checkbox = memo(({ checked, onChange, disabled }: Props) => {
  return (
    <MuiCheckbox
      tabIndex={-1}
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      icon={
        <span
          style={{
            display: 'inline-block',
            width: 24,
            height: 24,
            position: 'relative',
          }}
        >
          <CheckBoxOutlineBlankIcon
            sx={{ color: disabled ? 'neutral.lighter' : 'neutral.light', fontSize: 24 }}
          />
        </span>
      }
      checkedIcon={
        <span
          style={{
            display: 'inline-block',
            width: 24,
            height: 24,
            position: 'relative',
          }}
        >
          <CheckBoxOutlineBlankIcon
            sx={{
              color: 'primary.main',
              fontSize: 24,
            }}
          />
          <CheckIcon
            sx={{
              color: 'primary.main',
              fontSize: 18,
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
            }}
          />
        </span>
      }
      sx={{ padding: 0 }}
    />
  );
});
